import { bindable, customElement, inject } from 'aurelia-framework';
import { NumeralConverter } from '@dynamik/common';
@customElement('ag-numeric-editor')

@inject(NumeralConverter)
export class AgNumericEditor {
  constructor(private numeralConverter: NumeralConverter) { }

  @bindable()
  hasFocus = false;

  @bindable()
  params: { colDef: { cellEditorParams: { format: string } }, value: number, eventKey?: string };
  paramsChanged() {
    if (this.params.colDef.cellEditorParams?.format) {
      this.format = this.params.colDef.cellEditorParams.format;
    }

    const eventKey = this.params.eventKey;
    if (eventKey === 'Backspace' || eventKey === 'Delete') {
      this.value = '';
      this.selectAllOnAttach = false;
      return;
    }

    if (eventKey && eventKey.length === 1) {
      this.value = eventKey;
      this.selectAllOnAttach = false;
      return;
    }

    this.value = this.numeralConverter.format(this.params.value, this.format);
    this.selectAllOnAttach = true;
  }

  @bindable
  format: string = 'twoDec';

  private eInput: any;
  private inputElement: any;
  private selectAllOnAttach = false;
  value: string;

  attached() {
    this.eInput = this.inputElement;
    // new AutoNumeric(this.eInput, autoNumericOptionsFourDecimal);
    this.hasFocus = true;
    this.eInput.focus();
    if (this.selectAllOnAttach) {
      setTimeout(() => this.eInput.select());
    }
  }

  getGui() {
    return this.eInput;
  }

  getValue() {
    return this.numeralConverter.parse(this.value);
  }

  focusIn() {
    this.eInput.focus();
  }
}
